module.exports = {"542221100":"泽当镇","542221101":"昌珠镇","542221200":"颇章乡","542221201":"结巴乡","542221202":"多颇章乡","542221203":"索珠乡","542221204":"亚堆乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/542221.json
// module id = 2746
// module chunks = 0